//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["search_info"],
  data() {
    return {
      INPUT:"",
      hide_input1: true
    };
  },
  methods:{
    
    go_search(){
      this.$emit("go_search",this.INPUT)
    }
    
  }
};
